import React, { useEffect, useRef, useState } from 'react';

/**
 * Componente de Ad Slot integrado com ads.andersonstaub.com
 * @param {string} position - Posição do anúncio (header-inner, sidebar-inner, content-inner, footer-inner)
 */
const AdSlot = ({ position }) => {
  const slotRef = useRef(null);
  const [loaded, setLoaded] = useState(false);

  useEffect(() => {
    const loadAd = async () => {
      try {
        const API = 'https://ads.andersonstaub.com/api';
        const page = encodeURIComponent(window.location.pathname);
        const res = await fetch(`${API}/ads?position=${position}&page=${page}`);
        
        if (!res.ok) return;
        
        const data = await res.json();
        if (data && data.html && slotRef.current) {
          slotRef.current.innerHTML = data.html;
          setLoaded(true);
        }
      } catch (e) {
        // Silently skip errors
        console.debug('Ad not loaded:', position);
      }
    };

    loadAd();
  }, [position]);

  return (
    <div 
      ref={slotRef}
      className={`ad-slot-inner ${loaded ? 'ad-loaded' : ''}`}
      data-position={position}
    />
  );
};

export default AdSlot;
